import { useEffect } from 'react';
import { useRouter } from '@tanstack/react-router';
import { trpc } from '@/client/utils/trpc';

export function useAdminGuard() {
  const router = useRouter();
  const { data: me, isLoading } = trpc.user.me.useQuery();

  useEffect(() => {
    if (!isLoading && me?.role !== 'ADMIN') {
      router.navigate({ to: '/timesheets' });
    }
  }, [me, isLoading, router]);

  return { me, isLoading };
}
